import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@splashthat/doppler/Button';
import EyeOn from '@splashthat/doppler/icons/EyeOn';
import EyeOff from '@splashthat/doppler/icons/EyeOff';

const ShowHideButton = ({ visible, handleToggle, size }) => (
    <Button variant="ghost" size={size} onClick={handleToggle} ariaLabel="Toggle element visibility">
        {visible ? <EyeOn /> : <EyeOff />}
    </Button>
);

ShowHideButton.propTypes = {
    visible: PropTypes.bool.isRequired,
    handleToggle: PropTypes.func.isRequired,
    size: PropTypes.string,
};

ShowHideButton.defaultProps = {
    size: 'small',
};

export default ShowHideButton;
